import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getComplianceFiles, createComplianceFolder, renameComplianceFile, deleteComplianceFile } from "../../store/actions/filesActions";

import { FileManager } from "@cubone/react-file-manager";
import "./files.css";

function ComplianceFiles(props) {
    const { token, getComplianceFilesFN, complianceFiles, createComplianceFolderFN, renameComplianceFileFN, deleteComplianceFileFN, compliance_id } = props;

    const [forceReRender, setForceReRender] = useState(false);

   const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.demo1.raborisk.ai"
  : "https://api.demo1.raborisk.ai";

    useEffect(() => {
        getComplianceFilesFN(compliance_id);
    }, [compliance_id]);

    useEffect(() => {
        setForceReRender(false);
        setTimeout(() => {
            setForceReRender(true);
        }, 100);
    }, [complianceFiles]);

    const [currentPath, setCurrentPath] = useState("/");

    const onFileOpen = (file) => {
        if (file.isDirectory) {
            return setCurrentPath(file.path);
        }
        window.open(file.s3_path, '_blank');
    }

    const onDownload = (files) => {
        for (let file of files) {
            window.open(file.s3_path, '_blank');
        }
    }

    const onDelete = (files) => {
        for (let file of files) {
            deleteComplianceFileFN(file.id, compliance_id);
        }
    }

    return (
        <div className="p-4">
            {forceReRender &&
                <FileManager 
                    onFileUploaded={() => getComplianceFilesFN(compliance_id)}
                    files={complianceFiles}
                    enableFilePreview={false}
                    fileUploadConfig={{url: API_URL + "/api/files/add_compliance_file",headers: {Authorization: token,"current_folder": currentPath || "/",compliance_id: String(compliance_id) || "1" }}}
                    onCreateFolder={(folderName) => createComplianceFolderFN(folderName, currentPath, compliance_id)}
                    onRefresh={() => getComplianceFilesFN(compliance_id)}
                    onFileOpen={onFileOpen}
                    onDownload={onDownload}
                    onRename={(file, newName) => renameComplianceFileFN(file, newName, compliance_id)}
                    onDelete={onDelete}
                />
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        complianceFiles: state.files.complianceFiles
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getComplianceFilesFN: (c) => dispatch(getComplianceFiles(c)),
        createComplianceFolderFN: (folderName, currentFolder, c) => dispatch(createComplianceFolder(folderName, currentFolder, c)),
        renameComplianceFileFN: (file, newName, c) => dispatch(renameComplianceFile(file, newName, c)),
        deleteComplianceFileFN: (id, c) => dispatch(deleteComplianceFile(id, c))
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceFiles);